import { Link } from 'react-router-dom';
import MovieCard from '@/components/feature/MovieCard';
import type { MovieItem } from '@/mocks/movies';

interface CategorySectionProps {
  title: string;
  icon: string;
  type: 'movie' | 'tv' | 'variety';
  movies: MovieItem[];
}

export default function CategorySection({ title, icon, type, movies }: CategorySectionProps) {
  return (
    <section>
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-100 text-primary-600">
            <i className={icon}></i>
          </div>
          <h2 className="text-lg md:text-xl font-bold text-foreground-900">{title}</h2>
        </div>
        <Link
          to={`/category/${type}`}
          className="text-sm text-primary-600 hover:text-accent-600 flex items-center gap-1 cursor-pointer whitespace-nowrap"
        >
          查看全部 <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-5">
        {movies.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}